const TRADE_IN_LOOKUP_RESULT = (() => {
  const tradeInNumber = (tradeIn) => {
    const { mainIdentifier } = ORDER_TRADE_IN_LOOKUP_RESULT_COMPONENTS;
    const { tradeInNumberText } = TRADE_IN_LOOKUP_RESULTS_CONFIG;
    return mainIdentifier({
      identifierText: tradeInNumberText.replace('[trade_in_number]', tradeIn.uuidPrefix),
    });
  };

  const tradeInPlacedOn = (tradeIn) => {
    const { detailRow } = ORDER_TRADE_IN_LOOKUP_RESULT_COMPONENTS;
    const { placedOnText } = TRADE_IN_LOOKUP_RESULTS_CONFIG;
    const row = detailRow();
    row.textContent = placedOnText.replace(
      '[placed_on]',
      DATE_TIME_FORMATS.PADDED_NUMERIC_DATE.format(new Date(tradeIn.initiatedAt)),
    );
    return row;
  };

  const tradeInType = (tradeIn) => {
    const { detailRowWithLabel } = ORDER_TRADE_IN_LOOKUP_RESULT_COMPONENTS;
    const {
      indotiText,
      instiText,
      mitiText,
      typeLabelText,
    } = TRADE_IN_LOOKUP_RESULTS_CONFIG;

    let valueText;
    switch (tradeIn.tradeinType) {
      case 'miti':
        valueText = mitiText;
        break;
      case 'insti':
        valueText = instiText;
        break;
      case 'indoti':
        valueText = indotiText;
        break;
      }

    return detailRowWithLabel({
      labelText: typeLabelText,
      valueText,
    });
  };

  const MITI_TRADE_IN_CANCELED = [
    'CANCELED',
  ];

  const MITI_TRADE_IN_SHIPPED = [
    'TRADEIN_INBOUND',
    'WAYSTATION_INBOUND',
  ];

  const MITI_TRADE_IN_RECEIVED = [
    'TRADEIN_ARRIVED',
    'TRADEIN_PROCESSING',
    'WAYSTATION_ARRIVED',
    'DROPOFF_INITIATED',
    'DROPOFF_READY',
    'DROPOFF_PROCESSING',
  ];

  const MITI_TRADE_IN_ITEMS_PROCESSED = [
    'TRADEIN_REVIEW',
    'TRADEIN_PROCESSED',
    'TRADEIN_SPECIALIST',
  ];

  const MITI_TRADE_IN_COMPLETE = [
    'TRADEIN_COMPLETED',
    'DROPOFF_COMPLETED',
  ];

  const INSTI_TRADE_IN_CANCELED = [
    'CANCELED',
    'CANCELED_IN_STORE',
  ];

  const INSTI_TRADE_IN_COMPLETE = [
    'INSTI_COMPLETED',
  ];

  const tradeInStatus = (tradeIn) => {
    const { detailRowWithLabel } = ORDER_TRADE_IN_LOOKUP_RESULT_COMPONENTS;
    const {
      instiCanceledText,
      instiCompleteText,
      instiOpenedText,
      mitiCanceledText,
      mitiCompleteText,
      mitiItemsProcessedText,
      mitiReceivedText,
      mitiRequestedText,
      mitiShippedText,
      statusLabelText,
    } = TRADE_IN_LOOKUP_RESULTS_CONFIG;

    let valueText;
    switch (tradeIn.tradeinType) {
      // TODO: Separate display statuses for indoti. The following are appropriate to miti, not
      // indoti.
      case 'miti':
      case 'indoti':
        if (MITI_TRADE_IN_COMPLETE.includes(tradeIn.state)) {
          valueText = mitiCompleteText;
        } else if (MITI_TRADE_IN_ITEMS_PROCESSED.includes(tradeIn.state)) {
          valueText = mitiItemsProcessedText;
        } else if (MITI_TRADE_IN_RECEIVED.includes(tradeIn.state)) {
          valueText = mitiReceivedText;
        } else if (MITI_TRADE_IN_SHIPPED.includes(tradeIn.state)) {
          valueText = mitiShippedText;
        } else if (MITI_TRADE_IN_CANCELED.includes(tradeIn.state)) {
          valueText = mitiCanceledText;
        } else {
          valueText = mitiRequestedText;
        }
        break;
      case 'insti':
        if (INSTI_TRADE_IN_COMPLETE.includes(tradeIn.state)) {
          valueText = instiCompleteText;
        } else if (INSTI_TRADE_IN_CANCELED.includes(tradeIn.state)) {
          valueText = instiCanceledText;
        } else {
          valueText = instiOpenedText;
        }
        break;
    }

    return detailRowWithLabel({
      labelText: statusLabelText,
      valueText,
    });
  };

  const tradeInItemThumbnails = (tradeIn) => {
    const { thumbnails } = ORDER_TRADE_IN_LOOKUP_RESULT_COMPONENTS;
    return thumbnails({
      images: tradeIn.tradeinItems.map(({ catalogItemTitle, itemImageUrl }) => ({
        imgUrl: itemImageUrl,
        altText: catalogItemTitle,
      })),
    });
  };

  const tradeInStatusUrl = (tradeIn) => {
    let handle;
    switch (tradeIn.tradeinType) {
      case 'miti':
        handle = 'trade-in-status';
        break;
      case 'indoti':
        // TODO: We're planning to introduce trade-in-status-indoti in the future.
        handle = 'trade-in-status';
        break;
      case 'insti':
        handle = 'trade-in-status-instore';
        break;
    }

    return `${Shopify.routes.root}pages/${handle}?tradeinuuid=${encodeURIComponent(tradeIn.uuid)}`;
  };

  const tradeInLookupResult = (tradeIn) => {
    const { resultContainer } = ORDER_TRADE_IN_LOOKUP_RESULT_COMPONENTS;
    const { isTypeVisible } = TRADE_IN_LOOKUP_RESULTS_CONFIG;

    const container = resultContainer({
      href: tradeInStatusUrl(tradeIn),
    });

    container.append(
      tradeInNumber(tradeIn),
      tradeInPlacedOn(tradeIn),
      ...(isTypeVisible ? [tradeInType(tradeIn)] : []),
      tradeInStatus(tradeIn),
      tradeInItemThumbnails(tradeIn),
    );

    return container;
  };

  return {
    tradeInLookupResult,
  };
})();
